import React, { useState, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
  selectSearchIsLoading,
  selectSearchLocation,
} from '../../store/data/data.selector';

import { TextField, CircularProgress } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import Section from '../section/section.component';

import './location-search.styles.scss';
import { getSearchLocationAsync } from '../../store/data/data.slice';

export default function LocationSearch() {
  const [terms, setTerms] = useState('');
  const [searchVisible, setSearchVisible] = useState(false);

  const dispatch = useDispatch();
  const searchLocation = useSelector(selectSearchLocation);
  const searchIsLoading = useSelector(selectSearchIsLoading);

  useEffect(() => {
    if (searchLocation.name) {
      setTerms(searchLocation.name);
    }
  }, [searchLocation]);

  const handleChange = (event) => {
    setTerms(event.target.value);
  };

  const handleSearch = async (event, text = null) => {
    if (event.key === 'Enter' || text === 'search') {
      dispatch(getSearchLocationAsync(terms));
    }
  };

  const handleClickAway = () => {
    setSearchVisible(false);
  };

  const handleToggleOpen = () => {
    setSearchVisible(!searchVisible);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <div>
        <Section
          id='search-container'
          className={searchVisible ? '' : 'search-hidden'}
        >
          <div id='search-icon' onClick={handleToggleOpen}>
            {searchVisible ? <CloseIcon /> : <LocationSearchingIcon />}
          </div>
          <TextField
            id='search-field'
            label='Search'
            variant='standard'
            placeholder='i.e. Ithaca, NY'
            inputMode='search'
            value={terms}
            onKeyDown={handleSearch}
            onChange={handleChange}
            style={{ width: 'calc(100% - 20px)' }}
            InputProps={{
              endAdornment: (
                <>
                  {searchIsLoading ? (
                    <CircularProgress color='inherit' size={20} />
                  ) : null}
                  {terms !== '' ? (
                    <ArrowForwardIcon
                      id='enter-arrow'
                      onClick={(e) => handleSearch(e, 'search')}
                    />
                  ) : null}
                </>
              ),
            }}
          />
        </Section>
      </div>
    </ClickAwayListener>
  );
}
